document.addEventListener("DOMContentLoaded", function () {
  // Responsive limit
  function getLimit() {
    return window.innerWidth > 768 ? 8 : 8;
  }

  function applyLimitToGrid(grid) {
    const cards = grid.querySelectorAll('.image-card');
    const limit = getLimit();
    let hasHidden = false;

    // Track if "Load More" has been pressed for this grid
    if (grid.dataset.loadMorePressed === "true") {
      // Show all cards, remove button if present
      cards.forEach(card => card.style.display = "");
      const btn = grid.querySelector('.load-more-btn');
      if (btn) btn.remove();
      return;
    }

    cards.forEach((card, i) => {
      if (i < limit) {
        card.style.display = "";
      } else {
        card.style.display = "none";
        hasHidden = true;
      }
    });

    // Add or remove the load more button
    let btn = grid.querySelector('.load-more-btn');
    if (hasHidden) {
      if (!btn) {
        btn = document.createElement('button');
        btn.className = 'load-more-btn';
        btn.textContent = 'Load More';
        grid.appendChild(btn);

        btn.addEventListener('click', function () {
          grid.dataset.loadMorePressed = "true";
          cards.forEach(card => card.style.display = "");
          btn.remove();
        });
      }
    } else if (btn) {
      btn.remove();
    }
  }

  function applyLimitToAllGrids() {
    document.querySelectorAll('.image-card-grid').forEach(applyLimitToGrid);
  }

  applyLimitToAllGrids();
  window.addEventListener('resize', applyLimitToAllGrids);

  // Disable clicks for image-card links without real href
  document.querySelectorAll('.image-card-link.is-disabled').forEach(a => {
    a.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
  });
});